import React, { useEffect, useRef, useState,useContext } from "react";
import { UserContext } from "../OEMChanges/OemAssetsImport";
import { connect } from "react-redux";
import {
  toggleModalAction,
  getRedeemHistoryAction,
  getWithdrawRequestAction,
  getCancleWithdrawAction,
  toggleAlertAction,
} from "../redux/actions/userAction";
import Lottie from "lottie-react";
import Loading from "../models/Loading";
import RedeemCancel from "../models/RedeemCancel";
import RGCancleAlert from "../models/RGCancleAlert";
import { ServerStatusCodes } from "../ServerStatusCodes";
import { REDEEM_HISTORY } from "../Strings";
import { WebToNativeMessage } from "../Common/Utils";
import navarrow from "../assets/back_btn.png";
import processed from "../assets/tick.svg";
import pending from "../assets/pendingRedeem.svg";
import redeemReceived from "../assets/pendingAnimation.json";
import redeemFailed from "../assets/redeemFailed.json";
import redeemStatusLine from "../assets/Redeem-revamp/lineStatusgreen.png";
import redeemFailCrossicon from "../assets/Redeem-revamp/redeemfailCross.png";
import { RUPEE_SYMBOL } from "../Strings";
import UpArrow from "../assets/uparrow.png";
import DownArrow from "../assets/downarrow.png";
import emptyredeem from "../assets/emptyRedeem.svg";
import paidInstantIcon from '../assets/Redeem-revamp/paidInstantRedeemSuccess.svg'
import {
  ConsoleView,
  deviceDetect,
  isBrowser,
  isMobile,
  isTablet,
} from "react-device-detect";
import historyicon from "../assets/Redeem-revamp/History.svg";
import instantLightningBolt from "../assets/Redeem-revamp/lightingInstant.svg";

import axios from "../api/AxiosInstance";
// import "./redeemstyle.css";
import Pending_Redeem from "./Pending_Redeem";
import newIcon from "../assets/newRedeemSuccessIcon.svg"
import InformationBlueIcon from "../assets/informationBlue.svg";
import notifyAnim from "../assets/Bell.json";
import walletIcon1 from "../assets/wallet1.png";
import rightRibbon from "../assets/right8156.png";
import leftRibbon from "../assets/left8155.png";


const RedeemRequestSuccess = (props) => {
  const { getRedeemHistoryAction,
    userState,
    toggleModalAction,
    getWithdrawRequestAction,
    showRedeemStatusData,
    networkStatus,
    amount,
    withdrawType,
    channel,
    bankAccountNumber,
    handleBackClick,
    nameMethod,
    redeemhistory,
    pendingRedeemCount,
    userState: { cancleWithdrawRes },
    history } = props;
  const [state, setState] = useState({
    errors: {
      message: "",
    },
    tnx_refernce_id: "",
    amount: "",
    transactionId: "",
    description: "",
    type: "",
    selectedBank: {},
    createdAt: "",
    step: 0,
    withdraw_type: "",
    tnxhistoryData: [],
    token: window.sessionStorage["token"],
    channel: window.sessionStorage["channel"],
    isloading: true,
    isErrorMsgisShown: false,
    isViewRemoved: false,
  });

  const assets = useContext(UserContext);
  // const [openTxnDetails, setOpenTxnDetails] = useState(true)
  const [cancelStatus, setCancelStatus] = useState(null);
  const [activeSection, setActiveSection] = useState(null);

  const handleToggle = () => {
    // Call your function here
    // if(pushNotificationEnable === "false" || pushNotificationEnable === false){
    // WebToNativeMessage({"type":"OpenNotificationPermission"})
    // }
    props.handleToggle()

  };
  useEffect(() => {
    if (sessionStorage.getItem("channel") === "OEMAPS1") {
      //   import('./TransactionSummaryOEM.css');
      console.log("came into OEMAPS1")
      import('./redeemstyleOEM.css');
    } else {
      console.log("came into APS")
      import('./redeemstyle.css');
    }
  }, [])
  
  useEffect(() => {
    console.log("showRedeemStatusData in success page>>>", showRedeemStatusData)
    if (showRedeemStatusData) {
      let eventProperties = {
        acelevel: window.sessionStorage["aceLevel"],
        channel: window.sessionStorage["channel"],
        subscriptionType: window.sessionStorage["subscriptionType"],
        username: window.sessionStorage["screenName"],
        wallet_balance: window.sessionStorage["totalBalance"],
        redeemable_amount: showRedeemStatusData?.tdsAmount !== undefined ? showRedeemStatusData?.winningBucket + showRedeemStatusData?.tdsAmount : showRedeemStatusData?.winningBucket
      }
      WebToNativeMessage({
        type: "redeemCTEvent", eventName: "PF_c_RedeemRequestSuccessPage_View", eventProperties: eventProperties,
        TDSCashbackAmount: showRedeemStatusData.tdsCashbackAmount,
      })
      WebToNativeMessage({
        type: "mixpanelEvent", eventName: "PF_c_RedeemRequestSuccessPage_View", eventProperties: eventProperties,
        TDSCashbackAmount:showRedeemStatusData.tdsCashbackAmount,
      })
      WebToNativeMessage({
        type: "rstsData", rstsData: {
          eventData: {
            acelevel: window.sessionStorage["aceLevel"],
            channel: window.sessionStorage["channel"],
            subscription_type: window.sessionStorage["subscriptionType"],
            // username: window.sessionStorage["screenName"],
            player_id: window.sessionStorage["screenName"],
            wallet_balance: window.sessionStorage["totalBalance"],
          },
          isevent: "yes",
          tableName: "pf_c_redeemrequestsuccesspage_view"
        }
      })
    }

  }, [showRedeemStatusData])

  const toggleSection = (index) => {
    setActiveSection((prevIndex) => (prevIndex === index ? null : index));
  };
  //   useEffect(async () => {
  //     console.log(window.sessionStorage["token"], "tokenn")
  //     await axios.post(process.env.REACT_APP_BASE_URL + "redeem/redeem_history/", { headers: { 'Authorization': ¸ } })
  //     .then( (async response => {
  //         setRedeemHistoryDetails(response.data)
  //         console.log(response.data,  "data123")
  //     }))
  //     .catch((e) => {
  //         console.log('error in getting redeem details',e)
  //     })

  // }, [])

  // useEffect(() => {
  //   async function fetchData() {
  //     // await getRedeemHistoryAction(window.sessionStorage["token"]);
  //     await getWithdrawRequestAction(
  //       window.sessionStorage["token"],
  //       amount,
  //       withdrawType,
  //       channel,
  //       bankAccountNumber,
  //       nameMethod
  //     );
  //   }
  //   fetchData();
  // }, []);
  console.log("showRedeemStatusData", showRedeemStatusData);

  const updateRequestResponse = async (statusCode, msg) => {
    console.log("Cancel Request Message:", statusCode, msg);
    setState((prevState) => ({
      ...prevState,
      token: window.sessionStorage["token"],
      channel: window.sessionStorage["channel"],
      isErrorMsgisShown: false,
      isloading: true,
    }));
  };
  const handleCancleRequest = async (
    tnx_id,
    amount,
    redeemOption,
    transactionId,
    timestamp,
    cancelConfirmationInfoMsg,
    processingFeeAmount,
    transactionType,
    isSmartRedeem
  ) => {
    let userDetails = userState.profileData;
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const epoch = new Date(timestamp);
    const createdAtDate =
      epoch.getDay() +
      " " +
      months[epoch.getMonth()] +
      " " +
      epoch.getFullYear() +
      ", " +
      epoch.getHours() +
      ":" +
      epoch.getMinutes() +
      ":" +
      epoch.getSeconds();

    WebToNativeMessage({
      type: "redeemCTEvent",
      eventName: "pf_c_redeemcancelclick",
      eventProperties: {
        username: userDetails.screenName,
        channel: window.sessionStorage["channel"],
        aceLevel: userDetails.currentAceLevelName,
        redeemid: transactionId,
        redeemAmount: amount,
        processingFeeAmount: processingFeeAmount,
        timestamp: createdAtDate,
        Location: 'RedeemRequestSuccess',
        RedeemType: transactionType
      },
    });
    WebToNativeMessage({
      type: "mixpanelEvent",
      eventName: "pf_c_redeemcancelclick",
      eventProperties: {
        username: userDetails.screenName,
        channel: window.sessionStorage["channel"],
        aceLevel: userDetails.currentAceLevelName,
        redeemid: transactionId,
        redeemAmount: amount,
        processingFeeAmount: processingFeeAmount,
        timestamp: createdAtDate,
        Location: 'RedeemRequestSuccess',
        RedeemType: transactionType
      },
    });

    toggleModalAction(
      true,
      <RedeemCancel
        tnx_id={tnx_id}
        cancelConfirmationInfoMsg={cancelConfirmationInfoMsg}
        transactionType={transactionType}
        transactionId={transactionId}
        redeemableamount={showRedeemStatusData.tdsAmount !== undefined ? showRedeemStatusData.winningBucket + showRedeemStatusData.tdsAmount : showRedeemStatusData.winningBucket}
        redeemOption={redeemOption}
        click_location='Redeem Success Page'
        updateRequestResponse={updateRequestResponse}
        cancelStatusCode={cancleWithdrawRes.statusCode}
        history={history}
        isSmartRedeem={isSmartRedeem}
        location={"Redeem_Success_Page"}
        redeemAmount={showRedeemStatusData.tdsAmount !== undefined ? showRedeemStatusData.winningBucket + showRedeemStatusData.tdsAmount : showRedeemStatusData.winningBucket}
        handleRefresh={() => {
          WebToNativeMessage(
            {
              type: "redeemCTEvent", eventName: "PF_c_RedeemHistory_pageload", eventProperties: {
                Click_Location: "PlacementSuccessPage onSuccessCancelRedeem",
                acelevel: window.sessionStorage["aceLevel"],
                channel: window.sessionStorage["channel"],
                subscriptionType: window.sessionStorage["subscriptionType"],
                username: window.sessionStorage["screenName"],
                count_pendingRedeem: pendingRedeemCount,
                Source: 'Redeem Page'
              }

            })
          WebToNativeMessage(
            {
              type: "mixpanelEvent", eventName: "PF_c_RedeemHistory_pageload", eventProperties: {
                Click_Location: "PlacementSuccessPage onSuccessCancelRedeem",
                acelevel: window.sessionStorage["aceLevel"],
                channel: window.sessionStorage["channel"],
                subscriptionType: window.sessionStorage["subscriptionType"],
                username: window.sessionStorage["screenName"],
                count_pendingRedeem: pendingRedeemCount,
                Source: 'Redeem Page'
              }

            })
          history.push("/redeemhistory/")
        }}
      />,
      true
    );
  };
  const getFormattedDate = (timeStamp) => {
    var a = new Date(timeStamp);
    var months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    var year = a.getFullYear();
    var month = a.getMonth() + 1;
    var date = a.getDate();
    var hour = a.getHours();
    var min = a.getMinutes();
    var ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12;
    hour = hour ? hour : 12; // the hour '0' should be '12'
    min = min < 10 ? "0" + min : min;
    var time =
      date + "/" + month + "/" + year + " " + hour + ":" + min + " " + ampm;
    return time;
  };

  const RedeemHistoryPageLoadCT = () => {
    WebToNativeMessage(
      {
        type: "redeemCTEvent", eventName: "PF_c_RedeemHistory_pageload", eventProperties: {
          Click_Location: "Track Request PlacementSuccessPage",
          acelevel: window.sessionStorage["aceLevel"],
          channel: window.sessionStorage["channel"],
          subscriptionType: window.sessionStorage["subscriptionType"],
          username: window.sessionStorage["screenName"],
          count_pendingRedeem: pendingRedeemCount,
          Source: 'Redeem Page'
        }

      })
    WebToNativeMessage(
      {
        type: "mixpanelEvent", eventName: "PF_c_RedeemHistory_pageload", eventProperties: {
          Click_Location: "Track Request PlacementSuccessPage",
          acelevel: window.sessionStorage["aceLevel"],
          channel: window.sessionStorage["channel"],
          subscriptionType: window.sessionStorage["subscriptionType"],
          username: window.sessionStorage["screenName"],
          count_pendingRedeem: pendingRedeemCount,
          Source: 'Redeem Page'
        }

      })
    history.push("/redeemhistory/")
  }

  const enableClickHandler = () => {
    WebToNativeMessage({ "type": "OpenNotificationPermission" })
  }

  return (
    <div style={{ backgroundColor: "#f9f9f9", position: 'absolute', width: '100%', height: '100%' }}>
      <div className="redeemSuccessHeader" >
        <img
          className="backBtn"
          src={assets?.assets?.navarrow}
          style={{ width: "40px", position: "absolute", left: "2%" }}
          onClick={() => {
            handleBackClick();
            WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_clickin_RedeemRequestSuccessPage", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], click_type: 'Back' } });
            WebToNativeMessage({ type: "mixpanelEvent", eventName: "PF_c_clickin_RedeemRequestSuccessPage", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], click_type: 'Back' } });
          }}
          alt="status"
        />
        Withdraw
        <img
          // className='backBtn'
          id="history_icon"
          alt="historybtn"
          src={assets?.assets?.historyicon}
          style={{ position: "absolute", right: "3%" }}
          onClick={() => {
            RedeemHistoryPageLoadCT();
            WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_clickin_RedeemRequestSuccessPage", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], click_type: 'History' } })
            WebToNativeMessage({ type: "mixpanelEvent", eventName: "PF_c_clickin_RedeemRequestSuccessPage", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], click_type: 'History' } })
          }}
        />
      </div>
      {console.log("showRedeemStatusData in success page>>> xxxxxxxxx", showRedeemStatusData)}

      <div className="successboby" >
        {showRedeemStatusData !== undefined ? (
          <div  id="invisable" style={{ ...(isTablet ? { width: '50%', marginLeft: "25%" } : { width: "100%" }), height: '100%', display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "" }}>
            { showRedeemStatusData.smartRedeemData && parseFloat(showRedeemStatusData.smartRedeemData.movedToWallet) ? 
            <div style={{ display: "flex", width: "92%", backgroundColor: "red", flexDirection: "column", alignItems: "center", justifyContent: "", borderBottom: showRedeemStatusData.winningBucket > 0? "1px solid #bababa" :"",marginBottom:"2%" }}>

              <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "", backgroundColor: "", marginTop: "5px" }}>
                <img src={assets?.assets?.newIcon} style={{ width: "50px", height: "50px" }}>
                </img>
              </div>

              <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "", marginTop: "5px" }}>
                <img src={assets?.assets?.walletIcon1} style={{ width: "20px", height: "20px", marginTop: "-5px" }}>
                </img>
                <span className="walletTransferSuccessText" style={{  fontSize: "0.8rem", fontWeight: "bold", marginLeft: "5px" }}>Moved to Your A23 Wallet</span>
              </div>

              <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "", marginTop: "5px" }}>

                <span id = "walletTransferAmount"className="walletTransferSuccessText" style={{  fontSize: "1.4rem", fontWeight: "bolder", marginLeft: "5px", marginTop: "2%", marginBottom: "2%" }}>{RUPEE_SYMBOL} {showRedeemStatusData.smartRedeemData.movedToWallet}</span>
              </div>

              { showRedeemStatusData.smartRedeemData && (showRedeemStatusData.smartRedeemData.instantBonus > 0) ? <div id="bonusBanner"style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "", marginTop: "5px" }}>

                {/* <span style={{color:"#000000",fontSize:"1.4rem",fontWeight:"bolder",marginLeft:"5px"}}>{RUPEE_SYMBOL} {showRedeemStatusData.smartRedeemData.movedToWallet}</span> */}
                <img src={assets?.assets?.leftRibbon} style={{height:"20px"}}></img>
                <div className="includeBonusBG" style={{ paddingLeft: "2%", paddingRight: "2%", paddingTop: "1%", paddingBottom: "1%" }}>
                  <span style={{ fontSize: "0.8rem", fontWeight: "bold", marginLeft: "5px",color:"black" }}>{RUPEE_SYMBOL}{showRedeemStatusData.smartRedeemData.instantBonus} Instant bonus included</span>
                </div>
                <img src={assets?.assets?.rightRibbon} style={{height:"20px"}}></img>
              </div> 
              : ""
              }


              <div style={{ width: "90%", display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", marginBottom: "5px",marginTop:"5px",padding:"5px" }}>

                <span style={{ color: "#707070", fontSize: "10px" }}>
                  *Amount transferred to A23 Wallet is used for playing cash games.
                  This amount cannot be moved back & is not redeemable.
                </span>

              </div>


             {(showRedeemStatusData.winningBucket > 0)? "":<div style={{width:"",display:"flex",justifyContent:"center",alignItems:"center",padding:"2%",backgroundColor:""}}>

              {/* <div className="flex flex-row mt2 w-90 justify-between " style={{width:"100%",padding:"2%"}}> */}
            <div
              className="RedeemSuccessActionButtonWhite"
              id="gotolobby"
              style={{
                width: "100%",
                height: "50%",
                padding:"12px 20px",
                whiteSpace:"nowrap",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "4px",
                fontWeight: "700",
                fontSize: "0.9rem",

              }}
              onClick={() => {
                WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_clickin_RedeemRequestSuccessPage", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], click_type: 'Go to Lobby' } });
                WebToNativeMessage({ type: "mixpanelEvent", eventName: "PF_c_clickin_RedeemRequestSuccessPage", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], click_type: 'Go to Lobby' } });
                // RedeemHistoryPageLoadCT()
                WebToNativeMessage({ type: 'goToLobby' })
              }}
            >
              Go to Lobby
            </div>
                </div>}




            </div> : ""}

{/* amount */}
{/* showRedeemStatusData.winningBucket */}
            { Math.abs(showRedeemStatusData.amount) > 0 ?<div style={{ width: "95%", backgroundColor: "", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
             { <div
                className="txnAnimation"
              >

                <div style={{ width: "50%", height: "100%", display: "flex", justifyContent: "center", alignItems: "",marginTop:"2%" }}>
                  {/* <Lottie
                  style={{ width: "100%", height: "100%" }}
                  animationData={
                    showRedeemStatusData.withdrawalSuccess === true
                      ? redeemReceived
                      : redeemFailed
                  }
                  autoPlay={true}
                  loop={true}
                /> */}
{/* style={{ width: "80%", height: "100%" }} */}
                  <img src={assets?.assets?.newIcon} style={{width:"50px",height:"50px"}} >
                  </img>
                </div>

              </div>}



              {/* pt4 */}

             { <div id="newRedeemAmount" className="StatusDisplay " style={{}}>
                <div className="fw7 f8 primary-blue pb2">
                  {showRedeemStatusData.withdrawalSuccess === true
                    ? "Withdrawal Requested for"
                    : ""}
                </div>
                <div id="requestedAmount"className="fw7 primary-blue" style={{ fontSize: "25px" }}>
                  {RUPEE_SYMBOL} {showRedeemStatusData.tdsAmount !== undefined ? Math.abs(showRedeemStatusData.newRedeemAmount) + showRedeemStatusData.tdsAmount : Math.abs(showRedeemStatusData.amount)}
                </div>

                {Math.abs(showRedeemStatusData.newRedeemAmount) > 0 ? <div>
                  <span id="netAmountAfterTDS" style={{fontSize:"0.7rem",fontWeight:"700"}}>Net Amount after TDS : {RUPEE_SYMBOL} {Math.abs(showRedeemStatusData.newRedeemAmount)}</span>
                  </div> :""}


                  {Math.abs(showRedeemStatusData.tdsCashbackAmount) > 0 ? <div>
                  <span  id="tdsCashbackAmount" style={{fontSize:"0.7rem",fontWeight:"700"}}>(<span  className="tdsCashGotValue"> +</span> <span  className="tdsCashGotValue">{RUPEE_SYMBOL} {Math.abs(showRedeemStatusData.tdsCashbackAmount)} Bonus </span><span className=""> as TDS Cashback </span>)</span>
                  </div> :""}
              </div>}



              <div className="ButtonComponent"
        style={{
          width: "100%",
          // height: "10%",
          paddingTop:"1%",paddingBottom:"2%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {showRedeemStatusData.withdrawalSuccess === true && !showRedeemStatusData.disableRedeemCancelFlag ? (
          <div className="flex flex-row mt2 w-90 justify-between " style={{width:"100%",padding:"2%"}}>
            <div
              className= "RedeemSuccessActionButtonWhite"
              id="gotolobby"
              style={{
                width: "45%",
                padding:"0.8rem",
                height: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "4px",
                fontWeight: "700",
                fontSize: "0.9rem",

              }}
              onClick={() => {
                WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_clickin_RedeemRequestSuccessPage", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], click_type: 'Go to Lobby' } });
                WebToNativeMessage({ type: "mixpanelEvent", eventName: "PF_c_clickin_RedeemRequestSuccessPage", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], click_type: 'Go to Lobby' } });
                // RedeemHistoryPageLoadCT()
                WebToNativeMessage({ type: 'goToLobby' })
              }}
            >
              Go to Lobby
            </div>
            <div
              className= "RedeemSuccessActionButtonGreen"
              id="cancel_redeem"
              style={{
                width: "45%",
                whiteSpace:"nowrap",
                padding:"0.8rem",
                height: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "4px",
                fontWeight: "700",
                fontSize: "0.9rem",
              }}
              onClick={(e) => {
                handleCancleRequest(
                  showRedeemStatusData._id,
                  showRedeemStatusData.amountForFullCancellation,
                  nameMethod,
                  showRedeemStatusData.transactionReference,
                  showRedeemStatusData.createdAt,
                  showRedeemStatusData.cancelConfirmationInfoMsg,
                  showRedeemStatusData.processingFeeAmount,
                  showRedeemStatusData.transactionType,
                  showRedeemStatusData?.isSmartRedeem
                );
                WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_clickin_RedeemRequestSuccessPage", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], click_type: 'Cancel Redeem' } })
                WebToNativeMessage({ type: "mixpanelEvent", eventName: "PF_c_clickin_RedeemRequestSuccessPage", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], click_type: 'Cancel Redeem' } })


              }}

            >
              Cancel Withdraw
            </div>
          </div>
        ) : showRedeemStatusData.withdrawalSuccess === true && showRedeemStatusData.disableRedeemCancelFlag ?
          (
            <div className="flex  mt2 w-90">
              <div
                id="back_to_lobby"
                className="RedeemSuccessActionButtonGreen"
                style={{
                  width: "100%",
                  height: "60%",
                  padding:"12px 20px",
                  whiteSpace:"nowrap",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "4px",
                  fontWeight: "700",
                  fontSize: "0.9rem",
                }}
                onClick={() => {
                  WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_clickin_RedeemRequestSuccessPage", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], click_type: 'Go to Lobby' } });
                  WebToNativeMessage({ type: "mixpanelEvent", eventName: "PF_c_clickin_RedeemRequestSuccessPage", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], click_type: 'Go to Lobby' } });
                  // RedeemHistoryPageLoadCT()
                  WebToNativeMessage({ type: 'goToLobby' })
                }}

              >
                Go to Lobby
              </div>
            </div>
          )

          : ""}
      </div>

              {showRedeemStatusData.withdrawalSuccess && showRedeemStatusData.standardMessage !== "" && showRedeemStatusData.standardMessage !== undefined && showRedeemStatusData.standardMessage !== null && (
                <>
                  {/* marginLeft: "5%", */}
                  <div className="processedInfoDiv" style={{
                    width: "90%", borderRadius: "5px",
                    // height: "6.5%",
                    // height:"60px",
                    // paddingTop:"2%",
                    // paddingBottom:"2%",
                    fontSize: "0.75rem",
                    textAlign: "left",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '1rem',
                    marginTop: "1rem"
                  }}
                    onClick={() => WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemPolicy_PageView", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], click_location: 'Redeem Status' } })
                    }>
                    <div className="processedInfo" style={{ width: "2%", height: "100%", borderTopLeftRadius: "3px", borderBottomLeftRadius: "3px" }}></div>

                    <div style={{ width: "98%", height: "100%", backgroundColor: "", display: "flex", alignItems: "center", marginBottom: "2%", marginTop: "2%" }}>
                      <img src={assets?.assets?.InformationBlueIcon} style={{ width: "16px", height: "16px", paddingLeft: "5px" }} />
                      <span style={{ fontSize: "0.7rem", fontWeight: "600", marginLeft: "5px" }}> {showRedeemStatusData.standardMessage}</span>

                    </div>
                  </div>
                  {/* <div
                  style={{
                    width: "95%",
                    marginLeft: "2.5%",
                    height: "6%",
                    fontSize: "0.75rem",
                    color: "#283b5a",
                    textAlign: "center",
                    display:'flex',
                    alignItems:'center',
                    justifyContent:'center',
                    marginBottom: '1%'
                  }}
                  onClick={()=>WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemPolicy_PageView", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], click_location: 'Redeem Status' } })
                }
                >
                  {showRedeemStatusData.standardMessage}
                </div> */}
                </>
              )}
              {/*  height: "50%" */}
              <div className="txnDetails">
                <div id="request_details_complete" style={{ width: "100%", display: "flex", padding: "2%" }}>
                  <div
                    style={{ width: "100%", height: "90%" }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        position: "relative"
                      }}
                    >
                      <div
                        className="redeemSuccessDetails"
                        style={{
                          width: "100%",
                          height: "100%",
                          borderRadius: "5px 5px 5px 5px",
                          // borderTop: "0",
                        }}
                      >

                        {/* {!isBonusApplied ? '' :
                      <div className='txnSummary' >
                        <div className='summaryArea'>
                          {summaryTile({ summary: 'Add Cash', amount: addCashAmount === '' ? 0 : addCashAmount })}
                          {bonusInfo.bonus !== 0 && summaryTile({ summary: 'Locked Bonus', amount: bonusInfo.bonus < 0 ? 0 : bonusInfo.bonus })}
                          {bonusInfo.instantBonus !== 0 && summaryTile({ summary: 'Instant Bonus', amount: bonusInfo.instantBonus < 0 ? 0 : bonusInfo.instantBonus })}
                          {summaryTile({ summary: 'Total Balance', amount: parseInt(addCashAmount === '' ? 0 : addCashAmount) + parseInt(bonusInfo.bonus < 0 ? 0 : bonusInfo.bonus) + parseInt(bonusInfo.instantBonus < 0 ? 0 : bonusInfo.instantBonus) })}
                        </div>
                      </div>
                    } */}
                        <div
                          style={{
                            width: "90%",
                            height: "100%",
                            marginLeft: "5%",
                            // borderTop: "1px solid #bababa",
                          }}
                        >
                          {showRedeemStatusData.error !== undefined ? (
                            <div>{showRedeemStatusData.error.message}</div>
                          ) : (
                            <div
                              style={{
                                width: "100%",
                                height: "100%",
                                textAlign: "left",
                                fontSize: "0.8rem",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "left",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                className="pv2"
                                id="request_id"
                                style={{
                                  display: "flex",
                                  height: "30%",
                                  alignItems: "center",
                                }}
                              >
                                <div className="RedeemDetailsSuccessText" style={{ width: "50%" }}>
                                  Withdraw Type
                                </div>
                                <div
                                  style={{ width: "50%" }}
                                >
                                  {showRedeemStatusData.transactionType === "standard" ?
                                    <div id={`${showRedeemStatusData.transactionType}redeem`}
                                      style={{
                                        width: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >

                                      <div className="RedeemDetailsSuccessTextRight" style={{
                                        // width: "50%",
                                        fontWeight: "700",

                                      }}>
                                        Standard
                                      </div>
                                      <img className="standardIcon"
                                        style={{
                                          width: "0.8rem",
                                          marginLeft: "10px",
                                        }}
                                        src={assets?.assets?.standardIcon}
                                        alt="standard"
                                      />
                                    </div>
                                    : showRedeemStatusData.transactionType === "instant" ?
                                      <div id={`${showRedeemStatusData.transactionType}redeem`}
                                        style={{
                                          width: "100%",
                                          display: "flex",
                                          alignItems: "center",
                                          //  justifyContent: "space-between",
                                        }}
                                      >


                                        <div className="RedeemDetailsSuccessTextRight" style={{
                                          // width: "50%",
                                          fontWeight: "700",
                                        }} >
                                          Instant
                                        </div>
                                        <img
                                          style={{
                                            width: "0.7rem",
                                            marginLeft: "10px",
                                          }}
                                          src={assets?.assets?.PaidInstantIcon}
                                          alt="instant"
                                        />
                                      </div>
                                      : showRedeemStatusData.transactionType === "paidInstant" ?
                                        <div id={`${showRedeemStatusData.transactionType}redeem`}
                                          style={{
                                            width: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                            //  justifyContent: "space-between",
                                          }}
                                        >


                                          <div className="RedeemDetailsSuccessTextRight" style={{
                                            // width: "50%",
                                            fontWeight: "700",
                                          }} >
                                            Prime Instant
                                          </div>
                                          <img
                                            style={{
                                              width: "1rem",
                                              marginLeft: "10px",
                                            }}
                                            src={assets?.assets?.PaidInstantIcon}
                                            alt="paid instant"
                                          />
                                        </div> : ""
                                  }



                                </div>
                              </div>
                              <div
                                className="pv2"
                                id="request_id"
                                style={{
                                  display: "flex",
                                  height: "30%",
                                  alignItems: "center",
                                }}
                              >
                                <div className="RedeemDetailsSuccessText" style={{ width: "50%" }}>
                                  Withdraw ID
                                </div>
                                <div id = "withdrawId" className="RedeemDetailsSuccessTextRight"
                                  style={{
                                    width: "50%",
                                    fontWeight: "700",
                                  }}
                                >
                                  {showRedeemStatusData.transactionReference}
                                </div>
                              </div>
                              <div
                                className="pv2"
                                id="date_time"
                                style={{
                                  display: "flex",
                                  height: "30%",
                                  alignItems: "center",
                                }}
                              >
                                <div className="RedeemDetailsSuccessText" style={{ width: "50%" }}>
                                  Date and Time
                                </div>
                                <div id="withdrawDateTime" className="RedeemDetailsSuccessTextRight"
                                  style={{
                                    width: "50%",
                                    fontWeight: "700",
                                  }}
                                >
                                  {getFormattedDate(
                                    showRedeemStatusData.createdAt
                                  )}
                                </div>
                              </div>
                              <div
                                className="pv2"
                                id="redeem_mode"
                                style={{
                                  display: "flex",
                                  height: "30%",
                                  alignItems: "center",
                                }}
                              >
                                <div className="RedeemDetailsSuccessText" style={{ width: "50%" }}>
                                  Withdraw Mode
                                </div>
                                <div id="withdrawMode" className="RedeemDetailsSuccessTextRight"
                                  style={{
                                    width: "50%",
                                    fontWeight: "700",
                                  }}
                                >
                                  {showRedeemStatusData.name}
                                </div>
                              </div>
                              {showRedeemStatusData.transactionType === 'paidInstant' &&
                                <div
                                  className="pv2"
                                  id="redeem_mode"
                                  style={{
                                    display: "flex",
                                    height: "30%",
                                    alignItems: "center",
                                  }}
                                >
                                  <div className="RedeemDetailsSuccessText" style={{ width: "50%" }}>
                                    Processing Fee
                                  </div>
                                  <div id="processingFee" className="RedeemDetailsSuccessTextRight"
                                    style={{
                                      width: "50%",
                                      fontWeight: "700",
                                    }}
                                  >
                                    {RUPEE_SYMBOL}{showRedeemStatusData.processingFeeAmount}
                                  </div>
                                </div>
                              }
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* notifyAnimation */}

                {(props.checked === false || props.checked === "false") ? <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "90%", marginLeft: "auto", marginRight: "auto" }}>
                  <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "" }}>
                    <Lottie style={{ "width": "48px", "height": "32px" }}
                      animationData={notifyAnim}
                      autoPlay={true}
                      loop={true}
                    />
                    <div className="enableNotifyText" style={{ fontSize: "12px", width: "70%" }}>
                      Enable notifications for updates related to your withdraw request
                    </div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginRight: "12px" }}>
                    <div style={{ display: "flex", marginRight: "12px", fontSize: "12px", fontWeight: "bold" }}> Enable</div>
                    <label className="toggle-switch">
                      <input type="checkbox" checked={props.checked} onChange={handleToggle} />
                      <span className="slider"></span>
                    </label>
                  </div>
                </div> : ""}
              </div>
            </div> :"" }


          </div>
        ) : (
          <div style={{ width: "100%", height: "100%", display: 'flex', alignItems: 'center', justifyContent: 'center', position: "absolute", top: '0px', background: "rgba(0,0,0,0.5)" }}><Loading /></div>
        )}

      </div>
{/* button  */}
      
   
    </div>
  );
};

const mapStateToProps = (state) => ({
  userState: state.userState,
  networkStatus: state.userState.networkStatus,
});

export default connect(mapStateToProps, {
  toggleModalAction,
  getRedeemHistoryAction,
  getCancleWithdrawAction,
  getWithdrawRequestAction,
  toggleAlertAction,
})(RedeemRequestSuccess);


